import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AppComponent } from 'src/app/app.component';

import { ResourcesService } from 'src/app/services/resources/resources.service';

import { ZonaModel } from 'src/app/services/zones/models/zona.model';
import { environment } from 'src/environments/environment';
import { JqWidgets } from 'src/app/utils/jqWidgets';
import { SsoService } from 'src/app/services/sso/sso.service';
import { ZonesService } from 'src/app/services/zones/zones.service';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import { BasesEdificiosGridView } from 'src/app/interfaces/bases-edificios-grid-view';
import { MainComponent } from '../../main/main.component';

@Component({
  selector: 'app-edificios-instalaciones-base',
  templateUrl: './edificios-instalaciones-base.component.html',
  styleUrl: './edificios-instalaciones-base.component.css'
})
export class EdificiosInstalacionesBaseComponent implements OnInit {
  @ViewChild('gridMovilesAsignados') gridMovilesAsignados: jqxGridComponent;
  @ViewChild('gridMovilesLibres') gridMovilesLibres: jqxGridComponent;

  @Input() edificio: ZonaModel;

  isLoading: boolean = false;

  public tema = environment.tema;
  public langGrid = JqWidgets.getLocalization('es');

  constructor
  (
    private ssoService: SsoService,
    private zonesService: ZonesService,
    private resourcesService: ResourcesService
  ) {}

  public translate(text: string): string {
    return AppComponent.translate(text);
  }

  ngOnInit() {
    this.langGrid = JqWidgets.getLocalization(this.ssoService.getTicket().Usuario.Idioma.Codigo.substring(0, 2));
  }

  cargarGrids() {
    this.isLoading = true;

    this.getMovilesEdificio().finally(() => {
      this.getMoviles();
    });

    this.isLoading = false;
  }

  async getMovilesEdificio() {
    this.movilesAsignados = await this.zonesService.getZonasFromEdificios(this.edificio.Id);
    this.initGridMovilesAsignados();
  }

  async getMoviles() {
    const moviles = await this.resourcesService.getMoviles();
    moviles.forEach(movil => {
      if(!this.movilesAsignados.find(ma => ma.id === movil.Codigo)) {
        this.movilesLibres.push(this.zonesService.transformMovilToEdificiosGridView(movil));
      }
    });
    this.initGridMovilesLibres();
  }

  public columnsMoviles = [
    { datafield: 'id', hidden: true },
    { text: AppComponent.translate('Descripcion'), columntype: 'textbox', filtertype: 'textbox', datafield: 'nombre', width: 120, },
    { text: AppComponent.translate('Matricula'), columntype: 'textbox', filtertype: 'textbox', width: 70, datafield: 'matricula' },
  ];
  // GRID MOVILES ASIGNADOS
  public sourceMovilesAsignados: any;
  public adapterMovilesAsignados: any;
  public movilAsignadoSelect: BasesEdificiosGridView;
  movilesAsignados: BasesEdificiosGridView[] = [];

  initGridMovilesAsignados() {
    this.sourceMovilesAsignados = {
      datatype: 'json',
      datafields: [
        { name: 'id', type: 'number', map: 'id' },
        { name: 'nombre', type: 'string', map: 'nombre' },
        { name: 'matricula', type: 'string', map: 'matricula' },
      ],
      localdata: this.movilesAsignados,
    }
    this.adapterMovilesAsignados = new jqx.dataAdapter(this.sourceMovilesAsignados);
    this.gridMovilesAsignados.updatebounddata('data');
  }

  onRowSelectAsignada(event: any) {
    this.movilAsignadoSelect = this.movilesAsignados.find(m => m.id === event.args.row.bounddata.id);
  }

  // GRID MOVILES LIBRES
  public sourceMovilesLibres: any;
  public adapterMovilesLibres: any;
  public movilLibreSelect: BasesEdificiosGridView;
  movilesToUnasign: BasesEdificiosGridView[] = [];
  movilesLibres: BasesEdificiosGridView[] = [];

  initGridMovilesLibres() {
    this.sourceMovilesLibres = {
      datatype: 'json',
      datafields: [
        { name: 'id', type: 'number', map: 'id' },
        { name: 'nombre', type: 'string', map: 'nombre' },
        { name: 'matricula', type: 'string', map: 'matricula' },
      ],
      localdata: this.movilesLibres,
    }
    this.adapterMovilesLibres = new jqx.dataAdapter(this.sourceMovilesLibres);
    this.gridMovilesLibres.updatebounddata();
  }

  onRowSelectLibre(event: any) {
    this.movilLibreSelect = this.movilesLibres.find(m => m.id === event.args.row.bounddata.id);
  }

  // BOTONES ASIGNAR Y DESASIGNAR
  associateMovil() {
    this.movilesAsignados.push(this.movilLibreSelect);

    this.movilesLibres.splice(this.movilesLibres.findIndex(m => m.id = this.movilLibreSelect.id), 1);

    this.updateGridsData();
    this.gridMovilesLibres.unselectrow(this.gridMovilesLibres.getselectedrowindex());
  }

  disassociateMovil() {
    this.movilesLibres.push(this.movilAsignadoSelect);
    this.movilesToUnasign.push(this.movilAsignadoSelect);

    this.movilesAsignados.splice(this.movilesAsignados.findIndex(m => m.id = this.movilAsignadoSelect.id), 1);

    this.updateGridsData();
    this.gridMovilesAsignados.unselectrow(this.gridMovilesAsignados.getselectedrowindex());
  }

  updateGridsData() {
    if(this.sourceMovilesAsignados && this.sourceMovilesLibres) {
      this.sourceMovilesLibres.localdata = this.movilesLibres;
      this.gridMovilesLibres.updatebounddata('data');

      this.sourceMovilesAsignados.localdata = this.movilesAsignados;
      this.gridMovilesAsignados.updatebounddata('data');
    }
  }

  async onGuardarMoviles() {
    this.isLoading = true;
    let codMoviles = [];
    this.movilesAsignados.forEach(m => codMoviles.push(m.id));
    let data = {
      "idZona": this.edificio.Id,
      "moviles": codMoviles
    }

    try {
      await this.zonesService.asignMovilToZona(data);

      this.movilesToUnasign.forEach(async mta => {
        await this.zonesService.unasignMovilFromZona(this.edificio, mta);
      });

      this.isLoading = false;
      MainComponent.showSuccess('ATENCION', 'Cambios_guardados', 2000);
    } catch (error) {
      this.isLoading = false;
      MainComponent.showError('ATENCION', 'Ha_ocurrido_un_error', 2000);
    }
  }
}
